import {canUseDom} from "../utils/dom"
import debounce from 'lodash/debounce'
import theme from '../styles/theme'
import filter from 'lodash/filter'
import first from 'lodash/first'
import last from 'lodash/last'
import {getScreenBreakpoint} from '../selectors'
import {screenResize, screenBreakpoint} from '../actions'

const dispatchScreenResize = (store) => {
    var breakpoint = first(filter(theme.breakpoints, breakpoint => breakpoint >= window.innerWidth)) ||
        last(filter(theme.breakpoints, b => b)); //need to filter as these are properties and last will not work

    var currentBreakpoint = getScreenBreakpoint( store.getState() );
    if(currentBreakpoint !== breakpoint)
        store.dispatch(screenBreakpoint(breakpoint));

    store.dispatch(screenResize(window.innerWidth));
}

const applyScreenMiddleware = (store) => {
    if(!canUseDom) return;

    dispatchScreenResize(store);

    window.addEventListener('resize', debounce(() => {
        dispatchScreenResize(store);
    }, 100));
}

export default applyScreenMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/applyScreenMiddleware.js